export default {
  SET_PRODUCT_CATEGORIES(state, data) {
    state.product_categories = data
  },
  SET_MATERIALS(state, data) {
    state.materials = data
  },
  SET_MATERIALS_TABLE_ID(state, data) {
    state.materialsVid = data
  },
  SET_MATERIAL_REMAINS(state, data) {
    state.materialRemains = data
  },
  SET_MATERIALS_FOR_ENTERING(state, data) {
    state.materialsForEntering = data
  },
  SET_MODAL_DETAILS(state,data){
    state.details_modal = data
  },
  SET_MATERIALS_FOR_BUILDERS(state,data){
    state.material_for_builds = data
  }
}
